const LoginStatus = ({loginState}) => (
  <>
    {loginState.message && (
      <div
        className={`w-full border rounded-3xl px-4 py-2 mb-4 flex items-center gap-4 transition-all ${loginState.message_type === "error" ? "bg-red-50 border-red-200" : "bg-[#ecfdf5] border-[#d1fae5]"}`}
      >
        <div
          className={`p-2 rounded-xl ${loginState.message_type === "error" ? "bg-red-100" : "bg-[#d1fae5]"}`}
        >
          {loginState.message_type === "error" ? (
            <div className="w-6 h-6 text-red-600 font-bold flex items-center justify-center">
              ✕
            </div>
          ) : (
            <div className="w-6 h-6 text-[#10b981] font-bold flex items-center justify-center">
              ✓
            </div>
          )}
        </div>
        <p
          className={`font-medium ${loginState.message_type === "error" ? "text-red-800" : "text-[#065f46]"}`}
        >
          {loginState.message}
        </p>
      </div>
    )}
  </>
);

export default LoginStatus;
